/* eslint-disable */
window.ydk.config({
  debug: false,
  jsApiList: [
    'onBack',
    'ajax',
    'close',
    'setTitle',
    'jumpTuringHome',
    'isYD',
    'showTuringLoading',
    'hideTuringLoading',
    'toast'
  ]
})

window.ydk.extend({
  showTuringLoading: function(){
    ydk._invoke('showTuringLoading', {}, {});
  },
  hideTuringLoading: function(){
    ydk._invoke('hideTuringLoading', {}, {});
  },
  isYD: function(){
    ydk._invoke('isYD', {}, {});
  },
  /**
   * 设置页面标题
   * 参数 title：页面标题
   * 参数 showLine：是否显示标题栏下方的一条线
   */
  setTitle: function(params){
    ydk._invoke('setTitle', {
      title: params.title,
      showLine: params.showLine || false,
    }, params);
  },
  /**
   * 客户端点击返回按钮回调
   */
  onBack: function(params){
    ydk._on('onBack', {} , params);
  },
  /**
   * 测试系统：关闭当前窗口
   */
  close: function(params){
    ydk._invoke('close', {} , params);
  },
  /**
 * 跳转到小图灵首页
 */
   jumpTuringHome: function(params){
    ydk._invoke('jumpTuringHome', params , params);
  },
})
/* eslint-disable */
